import {defineMessages} from 'react-intl';

export default defineMessages({
  rangeInformedOne: {
    id: 'SectionRowSeat.rangeInformedOne',
    defaultMessage: 'You\'ll get 1 seat, starting with the lowest number available in the range',
  },
  rangeInformedBetween: {
    id: 'SectionRowSeat.rangeInformedBetween',
    defaultMessage: 'You\'ll get {quantity} seats together, starting with the lowest number available in the range',
  },
  rangeInformedAll: {
    id: 'SectionRowSeat.rangeInformedAll',
    defaultMessage: 'You\'ll get the {quantity} consecutive seats in the range',
  },
  rangeNotInformed: {
    id: 'SectionRowSeat.rangeNotInformed',
    defaultMessage:
      'Your {quantity, plural,=0{}one{seat will be}other{seats will be together and} } printed on the {quantity, plural,=0{}one{ticket}other{tickets}}',
  },
  singleNotInformed: {
    id: 'SectionRowSeat.singleNotInformed',
    defaultMessage: 'Your seat will be printed on the ticket',
  },
});
